module.exports = __webpack_public_path__ + "img/residence.b789fa9d.svg";